import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import Seo from "../components/Seo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, "Could not process that. Try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="max-w-md mx-auto px-4 py-16 sm:py-24" data-testid="forgot-password-page">
      <Seo title="Reset Your Password | HiredToday" description="Reset your HiredToday account password." path="/forgot-password" />
      {sent ? (
        <div data-testid="forgot-sent">
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-bold text-zinc-950">Check your inbox.</h1>
          <p className="mt-3 text-sm text-zinc-600 leading-relaxed">
            If an account exists for that email, a reset link is on its way. It works for 30 minutes. Worth a look in spam just in case.
          </p>
          <Link to="/login" data-testid="forgot-back-login" className="mt-6 inline-block text-sm font-medium text-blue-700 hover:text-blue-900">
            Back to log in
          </Link>
        </div>
      ) : (
        <>
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-bold text-zinc-950">Forgot your password?</h1>
          <p className="mt-2 text-sm text-zinc-500">Happens to everyone. Enter your email and we'll send a reset link.</p>
          {error && (
            <div className="mt-6 border border-red-200 bg-red-50 text-red-800 text-sm rounded-md px-4 py-3" data-testid="forgot-error">{error}</div>
          )}
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
            <div>
              <label className="text-sm font-medium text-zinc-700 block mb-1.5">Email</label>
              <input required type="email" data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full h-12 px-4 border border-zinc-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-600" />
            </div>
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full h-12 bg-zinc-950 text-white text-sm font-semibold rounded-md hover:bg-zinc-800 transition-colors duration-200 disabled:opacity-50">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
          <p className="mt-6 text-sm text-zinc-500 text-center">
            Remembered it? <Link to="/login" data-testid="forgot-to-login" className="text-blue-700 font-medium">Log in</Link>
          </p>
        </>
      )}
    </main>
  );
}
